import React, { useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import "./styles.css";

export default function CompanySignUpForm({ handleSubmit }) {
  const [form, setForm] = useState({
    id: 0,
    companyName: "",
    contactFirstName: "",
    contactLastName: "",
    email: "",
    cellNumber: "",
    altContact1: "",
    altContact2: "",
    country: "",
    region: "",
    postalCode: "",
    webSite: "",
    servicesProvided: "",
    geographicalExpertise: "",
    supportedRegions: "",
    numberOfEmployees: 0,
    specialty: "",
    ein: "",
    isApproved: false,
    isDeleted: false,
    regions: "",
    projectTypeId: [],
    geographicPresence: "",
    question1: "",
    question2: "",
    question3: "",
    question4: "",
    geographicContinent: [],
    geographicCountry: [],
    geographicRegion: [],
  });
  const types = [
    {
      id: "water",
      name: "Water",
    },
    {
      id: "food",
      name: "Food",
    },
    {
      id: "medicine",
      name: "Medicine",
    },
    {
      id: "specialty-name",
      name: "Specialty Name",
    },
    {
      id: "agriculture",
      name: "Agriculture",
    },
    {
      id: "peace",
      name: "Peace",
    },
    {
      id: "trauma",
      name: "Trauma",
    },
    {
      id: "education",
      name: "Education",
    },
    {
      id: "pastoring",
      name: "Pastoring",
    },
    {
      id: "economic",
      name: "Economic",
    },
    {
      id: "disaster",
      name: "Disaster",
    },
    {
      id: "construction",
      name: "Construction",
    },
  ];

  const countryObj = countries.getNames("en", { select: "official" });
  countries.registerLocale(enLocale);
  const countryArr = Object.entries(countryObj).map(([key, value]) => {
    return {
      label: value,
      value: key,
    };
  });

  const handleInputChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(form);
      }}
    >
      <Grid container item justifyContent="center" spacing={3} mb={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label="Company Name"
            name="companyName"
            value={form.companyName}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            fullWidth
            label="First Name"
            name="contactFirstName"
            value={form.contactFirstName}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            label="Last Name"
            name="contactLastName"
            value={form.contactLastName}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            label="Email"
            name="email"
            value={form.email}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Cell Number"
            name="cellNumber"
            value={form.cellNumber}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Alternative Contact #1"
            name="altContact1"
            value={form.altContact1}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Alternative Contact #2"
            name="altContact2"
            value={form.altContact2}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            required
            label="Country"
            name="country"
            value={form.country}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            required
            label="Region"
            name="region"
            value={form.region}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            required
            fullWidth
            label="Postal Code"
            name="postalCode"
            value={form.postalCode}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Website"
            name="webSite"
            value={form.webSite}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Services Provided"
            name="servicesProvided"
            value={form.servicesProvided}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Geographical Expertise"
            name="geographicalExpertise"
            value={form.geographicalExpertise}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Regions"
            name="regions"
            value={form.regions}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="# of Employees"
            name="numberOfEmployees"
            value={form.numberOfEmployees}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="EIN"
            name="ein"
            value={form.ein}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" textAlign="left">
            Select all that apply.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth variant="filled">
            <InputLabel id="type">Specialities & Areas of Expertise</InputLabel>
            <Select
              labelId="type"
              value={form.projectTypeId || 0}
              name="projectTypeId"
              multiple
              onChange={(e) => {
                setForm({
                  ...form,
                  projectTypeId: e.target.value,
                });
              }}
            >
              {types.map((type) => {
                return (
                  <MenuItem key={type.id} value={type.id}>
                    {type.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth variant="filled">
            <InputLabel id="type">Continent</InputLabel>
            <Select
              value={form.geographicContinent}
              name="geographicContinent"
              multiple
              onChange={handleInputChange}
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="" disabled>
                Continent
              </MenuItem>
              <MenuItem value="africa">Africa</MenuItem>
              <MenuItem value="asia">Asia</MenuItem>
              <MenuItem value="oceana">Oceana</MenuItem>
              <MenuItem value="south-america">South America</MenuItem>
              <MenuItem value="north-america">North America</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth variant="filled">
            <InputLabel id="type">Country</InputLabel>
            <Select
              value={form.geographicCountry}
              name="geographicCountry"
              multiple
              inputProps={{ "aria-label": "Without label" }}
              onChange={handleInputChange}
            >
              {!!countryArr?.length &&
                countryArr.map(({ label, value }) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth variant="filled">
            <TextField
              fullWidth
              label="Region"
              name="geographicRegion"
              value={form.geographicRegion}
              onChange={handleInputChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="When can you begin operations?"
            name="question1"
            value={form.question1}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Do you provide any financial benefits or assets to local or national governments? (please thoroughly explain)"
            name="question2"
            value={form.question2}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Closest organizational resources to project? - specify approximate distance"
            name="question3"
            value={form.question3}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Current projects in the area? - please describe"
            name="question4"
            value={form.question4}
            onChange={handleInputChange}
            multiline
            maxRows={6}
            minRows={6}
            inputProps={{ maxLength: 200 }}
          />
        </Grid>
        <Grid
          item
          container
          direction="column"
          alignItems="flex-start"
          justifyContent="flex-start"
          xs={12}
          md={12}
        >
          <Grid item my={2}>
            <Typography variant="body1" textAlign="center">
              We research all partners to ensure impactful, high integrity work.
            </Typography>
          </Grid>
          <Grid item>
            <Button variant="contained" size="small" type="submit">
              Request Access
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
